module.exports = __webpack_public_path__ + "img/货到付款.959dc80f.svg";